import { DialogContent, makeStyles } from '@material-ui/core';
import React, { FC, useEffect } from 'react';
import { useSelector } from 'react-redux';
import Actions from 'src/genericComponents/Dialog/Actions';
import { dispatch } from 'src/redux/config/configureStore';
import { RootState } from 'src/redux/config/rootReducer';
import { removeAllErrorsQueue } from 'src/redux/slices/general.slice';
import { DialogType } from 'src/redux/types/redux.types';
import { i18nService } from 'src/services/i18n.service';
import './StyledErrorModel.css';

export interface Props {
  appProps?: {
    onClose?: React.MouseEventHandler<any>;
  };
}
const useStyles = makeStyles(() => {
  return {
    container: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'baseline',
      maxHeight: 'calc(100vh - 239px)',
      overflow: 'auto',
      padding: '15px',
      backgroundColor: 'white',
      borderRadius: '10px',
      borderLeft: '15px solid #2164a3',
      minHeight: '120px',
      minWidth: '100%',
      maxWidth: '600px',
      textAlign: 'start',
    },
  };
});

const ErrorModalComponent: FC<Props> = ({ appProps }) => {
  const classes = useStyles();
  const defaultError = i18nService.translate('errors.api.alert.text', {
    status: 500,
  });

  //get errorMessageOpen from redux
  const { errorQueue } = useSelector((state: RootState) => state.general);

  useEffect(() => {
    // If there's no error in the queue, nothing to do
    if (errorQueue.length === 0) {
      return;
    }

    // Here, you can set up any effect that needs to run when the error queue updates.
    // For instance, if your modal logic is outside this useEffect, and depends on observing
    // changes to `errorQueue`, you'd trigger those changes here.
  }, [errorQueue, dispatch]);

  if (errorQueue.length === 0) {
    return null;
  }

  /**
   * Handle close button click - close the dialog and update redux state
   * @param e MouseEvent
   */
  const handleClose = (e: React.MouseEvent<HTMLButtonElement>) => {
    //update redux state
    dispatch(removeAllErrorsQueue());

    //close the dialog
    appProps?.onClose && appProps.onClose(e);
  };

  return (
    <>
      <DialogContent style={{ maxWidth: 1000, minWidth: '100%' }}>
        <div className="error-modal-text-container" dir="auto">
          {errorQueue
            ? errorQueue?.map((error, idx) => (
                <div key={idx} style={{ marginBottom: '10px' }}>
                  {`Status: ${error.errorStatus}`}
                  <br />
                  {error.title && `Title: ${error.errorTitle}`}
                  {error.title && <br />}
                  {`Text: ${error.errorText}`}
                  <br />
                </div>
              ))
            : defaultError}
          <br />
          <span className="error-modal-text">
            {i18nService.translate('errorModal.additionalMessage')}
          </span>
        </div>
      </DialogContent>
      <Actions type={DialogType.Alert} onClose={handleClose} />
    </>
  );
};

export default ErrorModalComponent;
